import React from 'react'
import './auth.styles.scss'

const AuthTemplate = (props) => {
    return (
        <div className="auth">
            <header>
                <h1><br/>Global Advanced Research Journals <br/> Admin</h1>
            </header>
            {props.children}
            <footer>
                <ul>
                    <li>
                        <a rel="noopener noreferrer" href="https://garj.org" >Main Site</a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" href="https://manuscripts.garj.org" target="_blank">Manuscript Submission</a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" href="https://garj.org/terms-conditions" target="_blank">Terms & Conditions</a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" href="https://garj.org/privacy-policy" target="_blank">Privacy Policy</a>
                    </li>
                </ul>
                <p>© 2024 Global Advanced Research Journals. All rights reserved.</p>
            </footer>
        </div>
    )
}

export default AuthTemplate